import { AutomationRuleDto } from './../interfaces/dto/automation-rule.dto';
import { Injectable } from "@angular/core";
import { EnvironmentService } from "../services/environment.service";
import { HttpClient,HttpResponse } from "@angular/common/http";
import { AutomationFlowConfig } from "../interfaces/automation-flow-config.interface";
import { map, Observable } from "rxjs";
import { AutomationRule } from "../interfaces/automation-rule.interface";
import { AutomationRuleAdapter } from "../adapters/automation-rule.adapter";
import { AutomationRulesResponse } from "../interfaces/automation-rule-response.interface";
import { AutomationRulesResult } from '../interfaces/automation-rule-result.interface';

@Injectable({
  providedIn: 'root'
})
export class AutomationService {
  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private ruleAdapter: AutomationRuleAdapter,
  ) { }

  getFlowConfigurations(): Observable<AutomationFlowConfig[]> {
    const url = this.environmentService.get('backendUrl') + `/automation/flow-configurations`;
    return this.http.get<AutomationFlowConfig[]>(url, {withCredentials: true}).pipe(
      map((response: AutomationFlowConfig[]) => {
        return response;
      })
    );
  }

  getRules(flow: AutomationFlowConfig, practiceId: string, page: number, perPage: number, status?: boolean): Observable<AutomationRulesResult> {
    let url = this.environmentService.get('backendUrl') + `/automation/flow/${flow.slug}/rules?practiceId=${practiceId}&page=${page}&perPage=${perPage}`;
    if (typeof status !== 'undefined') {
      url += `&dryRun=${status}`;
    }
    return this.http.get<AutomationRulesResponse>(url, {withCredentials: true}).pipe(
      map((response: AutomationRulesResponse) => {
        return {
          rules: response.rules.map((r) => this.ruleAdapter.run(r)),
          total: response.total,
          page: response.page,
          perPage: response.perPage,
          totalPages: response.totalPages,
          currentPage: response.currentPage,
          hasMore: response.hasMore
        };
      })
    );
  }

  getDryRunExport(flowConfig: AutomationFlowConfig, ruleIds: string[], sendAtFrom: string, sendAtTo: string, practiceId: string): Observable<HttpResponse<Blob>> {
    const url = this.environmentService.get('backendUrl') + `/automation/dry-run-export?practiceId=${practiceId}`;
    return this.http.post(url, { 
      flowConfig,
      ruleIds, 
      sendAtFrom, 
      sendAtTo, 
      practiceId 
    }, {
      withCredentials: true,
      responseType: 'blob',
      observe: 'response'
    });
  }

  saveRule(body: any, practiceId: string): Observable<AutomationRule> {
    let url = this.environmentService.get('backendUrl') + `/automation/rules`;

    if (body.id) {
      url += `/${body.id}?practiceId=${practiceId}`
    } else {
      url += `/?practiceId=${practiceId}`
    }

    return this.http.post<AutomationRuleDto>(url, {body: body}, {withCredentials: true}).pipe(
      map((res) => {
        return this.ruleAdapter.run(res);
      })
    );
  }

  setDryRunStatus(id: string, dryRun: boolean, practiceId: string): Observable<boolean> {
    const url = this.environmentService.get('backendUrl') + `/automation/rules/${id}/set-dry-run-status?practiceId=${practiceId}`;
    return this.http.patch<void>(url, {dryRun: dryRun}, {withCredentials: true}).pipe(
      map(() => {
        return true;
      })
    );
  }

  deleteRule(id: string, practiceId: string): Observable<boolean> {
    const url = this.environmentService.get('backendUrl') + `/automation/rules/${id}?practiceId=${practiceId}`;
    return this.http.delete<void>(url, {withCredentials: true}).pipe(
      map(() => {
        return true;
      })
    );
  }
}